<!-- MESSAGE BOKS START -->
<div *ngFor="let messageBox of messageBoxList; index as i;"  [@mbState]="messageBox.state">
    <!-- DESKTOP MED MARGIN -->
    <div class="alert alert-dismissable messageBox d-none d-md-block" [ngClass]="messageBox.class" role="alert">
        <div id="divMsg" [innerHtml]="messageBox.message"></div>
    </div>
    <!-- MOBIL UDEN MARGIN -->
    <div class="alert alert-dismissable mobileMessageBox d-sm-none" [ngClass]="messageBox.class" role="alert">
      <div id="divMsg" [innerHtml]="messageBox.message"></div>
  </div>
  </div>
  <!-- MESSAGE BOKS SLUT -->